export default __webpack_public_path__ + "static/media/rocket-cartoon.d32c4262.svg";